import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss']
})
export class SsoComponent extends DestructorComponent {

  constructor(
    private _router: Router,
    private _authService: AuthService
  ) { super(); }

  ngOnInit(): void {
    const queryParams = this._router.parseUrl(this._router.url).queryParams;
    const auth_code = queryParams['auth_code'];

    if (auth_code) {
      this.subscriptions.push(
        this._authService.GetSSOCode(auth_code).subscribe({
          next: (response) => {
            if(response && response.status && response.data && response.data.token) {
              localStorage.setItem('authToken', response.data.token);
              window.location.href = '/dashboard';
            } else {
              console.error('Invalid SSO response:', response);
              this._router.navigate(['/login']);
            }
          },
          error: (error) => {
            this._router.navigate(['/login']);
            console.error('Error getting SSO code:', error);
          }
        })
      );
    } else {
      this._router.navigate(['/login']);
    }
  }

}
